import ApiConstants from "../utils/apiConstants";
import { axios } from "../utils/axios";

const baseUrl = process.env.REACT_APP_API_HOST;

export const supplierFilter = async (filterData, page, size) => {
  try {
    let url = `${baseUrl}/${ApiConstants.SUPPLIERS}?page=${page}&size=${size}`;
    const queryParams = new URLSearchParams(filterData).toString();

    if (queryParams) {
      url += `&${queryParams}`;
    }
    
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSupplier = async (supplierData, supplierId) => {
  try {
    const url = `${baseUrl}/${ApiConstants.SUPPLIERS}/${supplierId}`;
    const response = await axios.put(url, supplierData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSuppliers = async (filterData, page = 1, size = 10) => {
  try {
    let url = `${baseUrl}/${ApiConstants.SUPPLIERS}?page=${page}&size=${size}`;
    const queryParams = new URLSearchParams(filterData).toString();

    if (queryParams) {
      url += `&${queryParams}`;
    }

    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addAggregatorTransaction = async (data) => {
  try {
    const response = await axios.post(`${baseUrl}/${ApiConstants.SUPPLIERS}/${ApiConstants.AGGREGATOR_TRANSACTION_ADD}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSupplierById = async (supplierId) => {
  try {
    const response = await axios.get(`${baseUrl}/${ApiConstants.SUPPLIERS}/${supplierId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAggregatorTransactions = async (supplierId, page = 1, size = 10) => {
  try {
    const response = await axios.get(`${baseUrl}/${ApiConstants.AGGREGATOR_TRANSACTION_GET}?supplier_id=${supplierId}&page=${page}&size=${size}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const filterAggregatorTransactions = async (supplierId, filterData) => {
  try {
    let url = `${baseUrl}/${ApiConstants.AGGREGATOR_TRANSACTION_GET}`;
    const params = new URLSearchParams({ supplier_id: supplierId, ...filterData });
    url += `?${params.toString()}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const exportAggregatorTransactions = async (supplierId, filters = {}) => {
  try {
    const params = new URLSearchParams({ supplier_id: supplierId });
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });
    const response = await axios.get(`${baseUrl}/${ApiConstants.AGGREGATOR_TRANSACTION_EXPORT}?${params.toString()}`, {
      responseType: "arraybuffer",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const exportSuppliers = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });
    const queryString = params.toString();
    const url = `${baseUrl}/${ApiConstants.SUPPLIERS_EXPORT}${queryString ? `?${queryString}` : ""}`;
    const response = await axios.get(url, {
      responseType: "arraybuffer",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelAggregatorTransaction = async (transactionId, admin_remarks) => {
  try {
    const response = await axios.delete(`${baseUrl}/${ApiConstants.AGGREGATOR_TRANSACTION_CANCEL}/${transactionId}`, { data: { admin_remarks } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const approveAggregatorTransaction = async (transactionId, admin_remarks) => {
  try {
    const response = await axios.patch(`${baseUrl}/${ApiConstants.AGGREGATOR_TRANSACTION_APPROVE}/${transactionId}/approve`, { admin_remarks });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const rejectAggregatorTransaction = async (transactionId, admin_remarks) => {
  try {
    const response = await axios.patch(`${baseUrl}/${ApiConstants.SUPPLIERS}/${ApiConstants.AGGREGATOR_TRANSACTION_REJECT}/${transactionId}/reject`, { admin_remarks });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAggregatorStatus = async (aggregatorId) => {
  try {
    const response = await axios.get(`${baseUrl}/${ApiConstants.SUPPLIER_AGGREGATOR_STATUS}?carrier_id=${aggregatorId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAggregatorStatus = async (supplierId, body) => {
  try {
    const response = await axios.patch(`${baseUrl}/${ApiConstants.SUPPLIERS}/${supplierId}/status`, body);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const saveBankDetails = async (bankData) => {
  try {
    const response = await axios.post(`${baseUrl}/${ApiConstants.SUPPLIERS}/bank-details`, bankData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
